<template>
	<div>
		<form v-on:submit.prevent="search()">
			<div class="input-group">
				<input type="text" class="form-control" v-bind:placeholder="Translate('@_UI_SEARCH')" aria-describedby="button-theses-search" ref="searchTerm" />
				<div class="input-group-append" v-if="String(filter).trim() !== ''">
					<button type="button" class="btn btn-outline-danger" aria-label="Close" v-on:click.prevent="clearFilter()">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="input-group-append">
					<button class="btn btn-primary" type="submit" id="button-theses-search" v-html="Translate('@_UI_SEARCH')"></button>
				</div>
			</div>
		</form>

		<div class="mt-2 mb-2">
			<div class="alert alert-warning mb-0" role="alert" v-html="Translate('@_UI_NO_RESULTS_FOUND')" v-if="results.length === 0 && String(filter).trim() !== ''"></div>
			<div class="table-responsive" v-if="results.length !== 0">
				<table class="table table-striped table-bordered" style="display: block; width: 100%; height: 400px; overflow: auto; overflow-y: scroll; overflow-x: hidden;">
					<thead>
						<tr>
							<th scope="col">
								<span>#</span>
							</th>
							<th scope="col">
								<span v-html="Translate('@_NAME')"></span>
							</th>
							<th scope="col">
								<span v-html="Translate('@_KIND')"></span>
							</th>
							<th scope="col">
								<span v-html="Translate('@_SEMESTER')"></span>
							</th>
							<th scope="col">
								<span v-html="Translate('@_GROUP')"></span>
							</th>
						</tr>
					</thead>
					<tbody >
						<tr v-for="(result, index) in results" v-bind:key="index">
							<th scope="row">								 
								<a href="javascript: void(0);" v-on:click.prevent="emitSelection(result)" ><i class="fas fa-plus"></i> {{result.code}}</a>
							</th>
							<td v-html="result.name"></td>
							<td v-html="result.kind"></td>
							<td v-html="result.semester"></td>
							<td v-html="result.group"></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

	</div>
</template>

<script>
import Mixin from "@/helpers/mixin";

export default {
	name: "CoursesSearch",
	mixins: [Mixin],
	data() {
		return {
			filter: "",
			results: []
		};
	},
	computed: {},
	methods: {
		emitSelection(obj) {
			//this.clearFilter();
			this.$emit("courseSelected", obj);
		},
		search() {
			let term = String(this.$refs.searchTerm.value).trim();
			this.$refs.searchTerm.value = term;
			this.filter = term;
		},
		clearFilter() {
			this.filter = "";
			this.$refs.searchTerm.value = "";
			this.results = [];
		},
		getData(InFilter) {
			let method = "http_get_courses";
			this.$store
				.dispatch(method, {
					search: String(InFilter).trim()
				})
				.then(resp => {
					this.results = Array.isArray(resp) ? resp : [];
				})
				.catch(e => {
					console.error(e);
				});
		}
	},
	watch: {
		filter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					if (String(newVal).trim().length >= 2) {
						this.getData(String(newVal).trim());
					}
				}
			}
		}
	},
	created() {
		this.getData('');
	}
};
</script>

<style scoped></style>
